/**
 * CalendarModificationEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { ProjectUserEntity } from "../ProjectUserEntity";
import { ExceptionalWorkingDayDateEntity } from "../ExceptionalWorkingDayDateEntity";
import { CalendarModification_PlanningEventEntity } from "../CalendarModification_PlanningEventEntity";
import { DocumentEntity } from "../DocumentEntity";
import { CalendarModificationEntity } from "../CalendarModificationEntity";
declare global {
    interface EntityTypeMap {
        CalendarModification: CalendarModificationEntity;
    }
}
export abstract class CalendarModificationGeneratedEntity extends BaseEntity {
    public abstract calendarModificationId: string;
    public abstract templateId: string | null;
    public abstract calendarModificationType: number;
    public abstract notes: string | null;
    public abstract text: string;
    public abstract type: string | null;
    public abstract creationDate: Date;
    public abstract startDate: Date;
    public abstract endDate: Date | null;
    public abstract duration: number | null;
    public abstract durationType: number;
    public abstract autoAdjustPlanning: boolean;
    public abstract isProjectScopeRelated: boolean;
    public abstract project: ProjectEntity;
    public abstract creator: ProjectUserEntity | null;
    public abstract readonly exceptionalWorkingDays: ReadonlyArray<ExceptionalWorkingDayDateEntity>;
    public abstract readonly planningEventRelations: ReadonlyArray<CalendarModification_PlanningEventEntity>;
    public abstract readonly relatedDocuments: ReadonlyArray<DocumentEntity>;
}
